<template>
  <form :action="exportToGoogleAction" name="google-sheets-form" method="POST" target="_blank" @click="submitForm">
    <template v-if="isListItemDisplayType">
      <c-icon icon="google" color="success" />
      <div class="c-button__dropdown__container__list__item__label">Выгрузить в Google Таблицы</div>
    </template>

    <c-button
      v-if="isButtonDisplayType"
      :icon="{
        icon: 'google',
        color: 'green',
      }"
      :disabled="disabled"
      label="Выгрузить в Google таблицы"
      responsive
    />
  </form>
</template>

<script>
import button from "@/components/controls/button";
import Icon from "@/components/icon";

const displayTypes = {
  LIST_ITEM: "list-item",
  BUTTON: "button",
};

export default {
  components: {
    "c-button": button,
    "c-icon": Icon,
  },
  props: {
    tableName: {
      type: String,
      default: () => "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    displayType: {
      type: String,
      default: "button",
      validator(value) {
        return Object.values(displayTypes).includes(value);
      },
    },
  },
  data() {
    return {
      queryParams: "",
    };
  },
  computed: {
    exportToGoogleAction() {
      const { userId } = this.$store.state;

      return `/index.php?r=google-sheets/create&user_id=${userId}&table=${this.tableName}&${this.queryParams}`;
    },
    isButtonDisplayType() {
      return this.displayType === displayTypes.BUTTON;
    },
    isListItemDisplayType() {
      return this.displayType === displayTypes.LIST_ITEM;
    },
  },
  methods: {
    update(params) {
      this.queryParams = params;
    },
    submitForm() {
      document.forms["google-sheets-form"].submit();
    },
  },
};
</script>

<style lang="scss" scoped>
.list-item-display-type {
  display: flex;
  align-items: center;
}
</style>
